import React from 'react';
import Field from './../field/Field';
import IntegrationAutosuggest from './../field/AutoSuggest';

export const mandatoryData = {
    clientId: {
        title: "ClientId *",
        data_validate: "^[0-9]+$",
        id: "clientId",
        name: "clientId",
        placeholder: "for example 50012",
        root: "target",
        error_msg: "Should not be empty"
    },
    affiliateId: {
        data_validate: "^[a-zA-Z0-9-]+$",
        title: "affiliate Id * ",
        id: "affiliateId",
        name: "affiliateId",
        placeholder: "for example us-airfind",
        error_msg: "Should not be empty",
        root: "target"
    },
    appId: {
        data_validate: "^[a-zA-Z0-9-._]+$",
        title: "application id * ",
        id: "appId",
        name: "appId",
        placeholder: "for example com.airfind.launcher",
        error_msg: "Should not be empty",
        root: "target"
    }
};

export const mandatoryUserProperties = (handleValueChange) => {
    return Object.keys(mandatoryData).map(item => {
        return (<Field
            data_validate={mandatoryData[item].data_validate}
            title={mandatoryData[item].title}
            id={mandatoryData[item].id}
            name={mandatoryData[item].name}
            placeholder={mandatoryData[item].placeholder}
            root={mandatoryData[item].root}
            error_msg="Should not be empty"
            key={mandatoryData[item].id}
            required="true"
            listener={handleValueChange}
        />);
    });
};

export const mandatoryUserPropertiesSuggest = (handleValueChange) => {
    return Object.keys(mandatoryData).map(item => {
        return (<IntegrationAutosuggest
            data_validate={mandatoryData[item].data_validate}
            title={mandatoryData[item].title}
            id={mandatoryData[item].id}
            name={mandatoryData[item].name}
            placeholder={mandatoryData[item].placeholder}
            root={mandatoryData[item].root}
            error_msg="Should not be empty"
            key={mandatoryData[item].id}
            required="true"
            listener={handleValueChange}
        />);
    });
};

export const generateMandatoryDataField = (item, data, handleValueChange) => {
    return (<IntegrationAutosuggest
        data_validate={item.data_validate}
        title={item.title}
        id={item.id}
        name={item.name}
        placeholder={item.placeholder}
        root={item.root}
        error_msg="Should not be empty"
        key={item.id}
        required="true"
        data={data}
        listener={handleValueChange}
    />);
}

export const generateUserField = (handleValueChange, removeCallback, field) => {
    return (<Field
        data_validate={field.data_validate}
        title={field.title}
        id={field.id}
        name={field.name}
        placeholder={field.placeholder}
        root={field.root}
        error_msg="Should not be empty"
        listener={handleValueChange}
        removeCallback={removeCallback}
    />);
}